module.exports = __webpack_public_path__ + "images/career-track-video-placeholder.png";